import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import { RESOLVED_LANGUAGE, FALLBACK_LOCALE } from './constants';

interface CreateI18n {
    messages: LocaleMessages;
}

Vue.use(VueI18n);

export const createI18n = (options: CreateI18n) => {
    return new VueI18n({
        locale: RESOLVED_LANGUAGE,
        fallbackLocale: FALLBACK_LOCALE,
        silentFallbackWarn: process.env.NODE_ENV !== 'development',
        messages: options?.messages,
    });
};
